import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/shared/mentionChipImage.ts
var MENTION_CHIP_IMAGE_PX = 20;
export {
  MENTION_CHIP_IMAGE_PX
};
//# sourceMappingURL=mentionChipImage.mjs.map